module.exports = __webpack_public_path__ + "fo.svg?887df537109a7e673fc83012ffffbccd";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/fo.svg
// module id = 807
// module chunks = 27